import React from "react";
import {Redirect, Route} from "react-router-dom";
import PropTypes from "prop-types";
import {isLogin} from "./Common";

// rutas privadas cuando esta en sesion
function PrivateRoute({ component: Component, ...rest }) {
  return <Route {...rest} render={props => isLogin() ? <Component {...props} /> : <Redirect to="/auth/login-page"/>}/>
}

PrivateRoute.propTypes = {
  component: PropTypes.func
};

export default PrivateRoute;
